import { BrowserRouter, Routes, Route } from "react-router-dom";
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './App.scss';
import Home from "./Components/Pages/index";
// import { Loader } from './Components/Organisms';
function App() {
  return (
    <div className="App">
      {/* <Loader /> */}
      <BrowserRouter>
        <Routes>
          <Route path="/*" element={<Home />} exact />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
export default App;